<template>
  <section class="invoice-preview-wrapper">
    <b-row
      v-if="agenda"
      class="invoice-preview"
    >
      <b-col
        cols="12"
        xl="9"
        lg="9"
        md="12"
        sm="12"
      >
        <b-card
          no-body
          class="invoice-preview-card"
        >
          <!-- Header -->
          <b-card-body class="pb-0">

            <div class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0">

              <!-- Header: Left Content -->
              <div>
                <div class="logo-wrapper">

                  <h3 class="text-primary">
                    اتوماسیون 5040
                  </h3>
                </div>
                <h3 class="card-text mb-25 pr-1">
                  {{ agenda.title }}
                </h3>
              </div>

              <!-- Header: Right Content -->
              <div class="mt-md-0 mt-2">
                <h4 class="invoice-title">
                  صورتجلسه شماره
                  <span class="invoice-number"> {{ agenda.id }}</span>
                </h4>
                <div class="invoice-date-wrapper">
                  <p class="invoice-date-title">
                    تاریخ ایجاد:
                  </p>
                  <p class="invoice-date">
                    {{ agenda.createdDate }}
                  </p>
                </div>
                <div class="invoice-date-wrapper">
                  <p class="invoice-date-title">
                    تاریخ جلسه:
                  </p>
                  <p class="invoice-date">
                    {{ agenda.meetingDate }}
                  </p>
                </div>
              </div>
            </div>
          </b-card-body>

          <hr
            v-if="agenda.description"
            class="invoice-spacing"
          >

          <b-card-body
            v-if="agenda.description"
            class="invoice-padding pt-0"
          >
            <span class="font-weight-bold">توضحیات: </span>
            <span v-html="agenda.description" />
          </b-card-body>
          <!-- Spacer -->
          <hr class="invoice-spacing">

          <!-- Invoice Client & Payment Details -->
          <b-card-body
            v-if="agenda.members"
            class="invoice-padding pt-0"
          >
            <b-row class="invoice-spacing">

              <b-col
                cols="12"
                class="p-0"
              >
                <h4 class="mb-2">
                  اعضای جلسه:
                </h4>
                <div class="row">
                  <b-list-group
                    v-for="(column , index) in columns"
                    :key="`cols${index}`"
                    class="col-md-6 mb-1"
                  >
                    <b-list-group-item
                      v-for="(item , key) in column"
                      :key="`col${key}`"
                    >
                      <span class="px-1">
                        {{ (key + 1) * (index + 1) }} )
                      </span>
                      {{ item.name }}
                    </b-list-group-item>
                  </b-list-group>
                </div>

              </b-col>
            </b-row>
          </b-card-body>

          <!-- Invoice Description: Table -->
          <b-table-lite
            responsive
            :items="agenda.approvals"
            :fields="fields"
          >

            <template #cell(index)="data">
              {{ data.index + 1 }}
            </template>

          </b-table-lite>
          <b-card-footer v-if="agenda.attachments && agenda.attachments.length">
            <div class="mail-attachments mt-1">
              <div class="d-flex align-items-center mb-1">
                <feather-icon
                  icon="PaperclipIcon"
                  size="16"
                />
                <h5 class="font-weight-bolder text-body mb-0 ml-50">
                  پیوست{{ agenda.attachments.length > 1 ? ' ها' : '' }} {{ agenda.attachments.length }}
                </h5>
              </div>

              <div class="d-flex flex-column">
                <b-link
                  v-for="(attachment, index) in agenda.attachments"
                  :key="index"
                  :href="attachment.url"
                  target="_blank"
                  :class="{'mt-75': index}"
                >
                  <!--                  <b-img-->
                  <!--                      :src="attachment.thumbnail"-->
                  <!--                      width="16px"-->
                  <!--                      class="mr-50"-->
                  <!--                  />-->
                  <span class="text-muted font-weight-bolder align-text-top">{{ attachment.fileName }}</span>
                  <span class="text-muted font-small-2 ml-25">({{ attachment.size }})</span>
                </b-link>
              </div>
            </div>
          </b-card-footer>
        </b-card>
      </b-col>
      <b-col
        cols="12"
        md="12"
        xl="3"
        lg="3"
        sm="12"
        class="invoice-actions"
      >
        <b-card>

          <!-- Button: Print -->
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            class="mb-75"
            block
            @click="printAgenda"
          >
            پرینت صورتجلسه
          </b-button>
        </b-card>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BButton, BTableLite, BCardText, BAlert, BLink, VBToggle, BCardFooter,
  BListGroup,
  BListGroupItem,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import Logo from '@core/layouts/components/Logo.vue'

export default {
  name: 'AgendaDetail',
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  components: {
    BCardFooter,
    BRow,
    BCol,
    BCard,
    BCardBody,
    BTableLite,
    BCardText,
    BButton,
    BAlert,
    BLink,
    Logo,
    BListGroup,
    BListGroupItem,
  },
  data() {
    return {
      agenda: {},
      fields: [
        {
          key: 'index',
          label: 'ردیف',
        },
        {
          key: 'title',
          label: 'عنوان',
        },
        {
          key: 'name',
          label: 'مجری',
        },
        {
          key: 'dueDate',
          label: 'مهلت اجرا',
        },
        {
          key: 'status',
          label: 'وضعیت',
        },
      ],
      cols: 2,
    }
  },
  computed: {
    columns() {
      const columns = []
      const mid = Math.ceil(this.agenda.members.length / this.cols)
      for (let col = 0; col < this.cols; col++) {
        columns.push(this.agenda.members.slice(col * mid, col * mid + mid))
      }
      return columns
    },
  },
  mounted() {
    this.getAgenda()
  },
  methods: {
    printAgenda() {
      window.print()
    },
    getAgenda() {
      this.$http.get(`agendas/${this.$route.params.id}`)
        .then(({ data }) => {
          if (data.status) {
            this.agenda = data.agenda
            this.loading = false
          } else {
            this.$bvToast.toast(data.message ?? 'اطلاعات نامه دریافت نشد', {
              title: 'حطا',
              toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
              variant: 'danger',
            })
          }
        })
        .catch(error => {
          this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
            title: 'خطا در دریافت اطلاعات',
            toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
            variant: 'danger',
          })
        })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
</style>

<style lang="scss">
@media print {

  // Global Styles
  body {
    background-color: transparent !important;
  }
  nav.header-navbar {
    display: none;
  }
  .main-menu {
    display: none;
  }
  .header-navbar-shadow {
    display: none !important;
  }
  .content.app-content {
    margin-left: 0;
    padding-top: 2rem !important;
  }
  footer.footer {
    display: none;
  }
  .card {
    background-color: transparent;
    box-shadow: none;
  }
  .customizer-toggle {
    display: none !important;
  }

  // Invoice Specific Styles
  .invoice-preview-wrapper {
    .row.invoice-preview {
      .col-md-8 {
        max-width: 100%;
        flex-grow: 1;
      }

      .invoice-preview-card {
        .card-body:nth-of-type(2) {
          .row {
            > .col-12 {
              max-width: 50% !important;
            }

            .col-12:nth-child(2) {
              display: flex;
              align-items: flex-start;
              justify-content: flex-end;
              margin-top: 0 !important;
            }
          }
        }
      }
    }

    // Action Right Col
    .invoice-actions {
      display: none;
    }
  }
}
</style>
